import React from 'react';
import { cx } from 'cva';
import Link from '@ui/Link';
import Typography from '@ui/Typography';
import ActionBar from './ActionBar';
import NonProfitCauses from './NonProfitCauses';
import NonProfitProfileBar from './NonProfitProfileBar';
import PostAuthorProfile from './PostAuthorProfile';
import PostMessage from './PostMessage';
import PostImage from './PostImage';
import PostVideo from './PostVideo';
import ReactionBar from './ReactionBar';
import OrgType from '@/constants/orgType.constant';
import PostTypeIndicatorChip from './PostTypeIndicatorChip';
import TrackPostVisibility from '../TrackPost/trackPostVisibility';
import {
  getPostLink,
  getProjectPostLink,
  shouldDisablePostCauses,
} from '@utils/post.helper';
import PostImageLink from './PostImageLink';

function ProjectPostBody(props) {
  const { post, type, home, orgSlug = null } = props;
  const { sourcePostData } = post;
  const { nonProfit, company } = post.renderProps;
  const { name, description } = sourcePostData;

  const hasVideo = post.renderProps.videoUrls && post.renderProps.videoUrls[0];
  let slug = post.renderProps?.company?.name.toLowerCase().replace(/\s+/g, '-');
  slug =
    post.renderProps?.company?.orgType === OrgType.NonProfit
      ? `nonprofit/${slug}`
      : `company/${slug}`;

  const disablePostCauses = shouldDisablePostCauses(home, orgSlug);
  const postLink = getPostLink(post);

  return (
    <TrackPostVisibility post={post} type={type}>
      <div>
        <div className="divide-y px-6 lg:px-4">
          <div className="flex flex-col gap-4 py-6 lg:py-4">
            {!disablePostCauses && nonProfit && nonProfit.causes && (
              <NonProfitCauses
                nonProfit={nonProfit}
                className="border-b pb-4"
              />
            )}

            <PostAuthorProfile post={post} home={home} orgSlug={orgSlug} />
          </div>

          <div className="flex w-full flex-col items-start justify-between gap-2 py-2 lg:flex-row">
            <Link href={postLink}>
              <Typography
                variant="h5"
                className="flex-1 group-hover:text-text-hyperlink">
                {name}
              </Typography>
            </Link>
            <div className="flex w-full items-center justify-between gap-2 lg:w-auto lg:flex-col lg:items-end">
              <PostTypeIndicatorChip postType={post.sourcePostType} />
            </div>
          </div>
        </div>

        {hasVideo ? <PostVideo post={post} /> : <PostImageLink post={post} />}

        {nonProfit && <NonProfitProfileBar nonProfit={nonProfit} post={post} />}

        <div className="flex flex-col gap-6 px-6 lg:px-4">
          <div className="divide-y">
            <div className="py-2">
              <PostMessage message={description} />
            </div>

            <ReactionBar post={post} />

            <div className="flex justify-center py-2">
              <ActionBar post={post} orgSlug={orgSlug} />
            </div>
          </div>
        </div>
      </div>
    </TrackPostVisibility>
  );
}

export default ProjectPostBody;
